module.exports = __webpack_public_path__ + "static/media/Strategie-en.5c7c1f56.jpg";